import { css } from '@emotion/core';
import { Headline3 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { Paragraph3 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '@olxeu-a2b/ui/src/theme/styled';
import mq from '../../../../../commons/styles/mediaQueries';

const Title = styled(Headline3)`
  ${mq.desktop} {
    display: none;
  }
`;

const UrlLink = styled(Paragraph3)`
  margin-top: 8px;
`;

const WarningMessage = styled.span`
  padding-left: 10px;
`;

const Snackbar = styled.div`
  background: ${({ theme }) => theme.colors.redLight};
  display: flex;
  padding: 8px 16px 8px 16px;
  border-radius: 3.7px;
  margin: 16px 0 16px;
  max-width: 1553px;
`;

const TabsContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  font-family: ${({ theme }) => theme.fonts.primary};

  ${mq.desktop} {
    background: ${({ theme }) => theme.colors.grey2};
  }
`;

const TabsList = styled.ul`
  margin-bottom: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  border-bottom: 0 solid transparent;
  gap: 8px;
  padding: 8px 8px 0px 8px;

  ${mq.desktop} {
    width: fit-content;
    gap: 0;
    padding: 0;
  }
`;

const TabListItem = styled.li<{ activeTab: boolean }>`
  cursor: pointer;
  flex-grow: 1;
  padding: 0 0 16px;
  position: relative;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  ${mq.mediumMobile} {
    flex-basis: 0;
  }

  ${mq.desktop} {
    padding: 32px 0;
    flex-basis: auto;
  }

  &::after {
    content: '';
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
    display: block;
    position: absolute;
    bottom: 0;
    transform: scaleX(0);
    width: 100%;
  }

  ${({ theme, activeTab }) =>
    activeTab &&
    css`
      font-weight: ${theme.fontWeights.medium};

      &::after {
        transform: scaleX(1);
      }
    `};
`;

const TabListItemTitle = styled.span`
  font-size: ${({ theme }) => theme.sizes.m};

  &:first-letter {
    text-transform: capitalize;
  }

  ${mq.desktop} {
    padding: 0 48px;
  }
`;

const TabPanel = styled.div<{ activeTab: boolean }>`
  display: none;

  ${({ activeTab }) =>
    activeTab &&
    css`
      display: flex;
      flex-flow: column;
    `}
`;

export default {
  Title,
  TabsContainer,
  TabsList,
  TabListItem,
  TabListItemTitle,
  TabPanel,
  WarningMessage,
  Snackbar,
  UrlLink,
};
